export const normalizeDropdownOptions = (rawOptions, source = "unknown") => {
  if (!rawOptions) return [];

  // Case 1: IndexedDB / API object { CONFIG: [...] }
  if (Array.isArray(rawOptions.CONFIG)) {
    return rawOptions.CONFIG.filter(
      (opt) => opt.CODE || opt.TEXT || opt.VALUE || opt.DESCRIPTION
    ).map((opt) => ({
      value: opt.CODE ?? opt.VALUE ?? opt.TEXT ?? "",
      label: opt.TEXT ?? opt.DESCRIPTION ?? opt.CODE ?? opt.VALUE ?? "",
    }));
  }

  // Case 2: array of { value, label }
  if (
    Array.isArray(rawOptions) &&
    rawOptions.every((opt) => opt && "value" in opt && "label" in opt)
  ) {
    return rawOptions.map((opt) => ({
      value: opt.value,
      label: opt.label,
    }));
  }

  // Case 3: array of strings
  if (
    Array.isArray(rawOptions) &&
    rawOptions.every((opt) => typeof opt === "string")
  ) {
    return rawOptions.map((opt) => ({
      value: opt,
      label: opt,
    }));
  }

  console.warn(`Unexpected dropdown format (${source}):`, rawOptions);
  return [];
};
